import { ShieldAlert } from "lucide-react";
import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import type { CreatedMcpConnection } from "@/services/mcp-connection.service";
import { McpCodeBlock } from "./McpCodeBlock";
import { McpSetupSnippets } from "./McpSetupSnippets";

export function McpTokenDialog({
	created,
	onClose,
}: {
	created: CreatedMcpConnection | null;
	onClose: () => void;
}) {
	return (
		<Dialog open={!!created} onOpenChange={(o) => !o && onClose()}>
			<DialogContent className="sm:max-w-2xl">
				<DialogHeader>
					<DialogTitle>Connect your agent</DialogTitle>
					<DialogDescription>
						This is the only time the token is shown. Paste the config into your
						agent now.
					</DialogDescription>
				</DialogHeader>

				{created && (
					<div className="space-y-4">
						<div className="flex items-start gap-2 rounded-md border border-danger/20 bg-danger-subtle p-3 text-xs text-danger">
							<ShieldAlert className="mt-0.5 h-4 w-4 shrink-0" />
							<p>
								Treat this token like a password. Anyone with it can act as you in
								TaskHub within the permissions you granted. Revoke it any time.
							</p>
						</div>
						<div className="space-y-1.5">
							<p className="text-xs font-medium text-muted-foreground">Token</p>
							<McpCodeBlock code={created.token} />
						</div>
						<div className="space-y-1.5">
							<p className="text-xs font-medium text-muted-foreground">Setup</p>
							<McpSetupSnippets token={created.token} initialClient={created.client} />
						</div>
					</div>
				)}

				<DialogFooter>
					<Button type="button" size="sm" onClick={onClose}>
						I've saved it
					</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	);
}
